import { memo } from 'react';

import { MessagesSquareIcon } from '@air/design-icons';

export const EmptyComments = memo(() => (
  <div className="flex h-full flex-col items-center justify-center gap-6 p-8" data-testid="EMPTY_COMMENTS">
    <MessagesSquareIcon size={40} className="ads:text-icon-subtle text-gray-8" />
    <div className="flex flex-col items-center gap-1">
      <p className="font-semibold ads:text-primary text-18 text-gray-12">No comments</p>
      <p className="text-center font-medium ads:text-metadata text-12 text-gray-9">
        Start the conversation by adding your feedback or annotations.
      </p>
    </div>
  </div>
));

EmptyComments.displayName = 'EmptyComments';
